export default "__VITE_ASSET__C5m5l$CQ__"